import { isEmpty, camelCase, pull, isNil } from 'lodash';

import { USER_TYPES } from 'constants/userTypes';
import { LOGIN_K12 } from 'routes/constants';

import {
  GUARDIAN_MODE_KEY,
  MIDDLE_HIGH_SCHOOL_MODE_KEY,
  ELEMENTARY_MODE_KEY,
  DASHBOARD_MODES,
} from 'modules/AccountSetupV2/widgets/K12DashboardSwitcher/constants';

export const getType = user => {
  const { isLoggedIn, isStudent } = {
    ...user,
  };
  let type = 'default';
  if (isLoggedIn) type = 'nonStudent';
  if (isStudent) type = 'student';

  return type;
};

export const getRelevantNavItems = (
  layout,
  types,
  key = 'sideNav',
  currentUserMode,
) => {
  if (isEmpty(layout) || !Array.isArray(types)) return [];
  let navType = types?.[0] || '';
  // when user has multiple user types
  // the later one in this list will get returned
  // e.g. user has both student and member,
  // here result should return member
  const userTypePriorityOrder = [
    USER_TYPES.STUDENT,
    USER_TYPES.MEMBER,
    USER_TYPES.K12_ADMIN,
  ];
  if (currentUserMode === GUARDIAN_MODE_KEY) {
    pull(userTypePriorityOrder, USER_TYPES.K12_ADMIN);
  }
  userTypePriorityOrder.forEach(el => {
    if (types?.includes(el)) navType = el;
  });
  return layout?.[camelCase(navType)]?.[key];
};

export const isElementaryPage = pathname => pathname.startsWith('/el');

export const getLogoLinkTo = ({
  isOnboarding,
  isStudent,
  isLoggedIn,
  isDemoStudent,
  currentUserMode,
}) => {
  if (isOnboarding && (isStudent || isDemoStudent)) {
    // During onboarding on click logo should not redirect to anywhere
    return '#';
  }

  if (!isNil(currentUserMode) && !(isStudent || isDemoStudent)) {
    return DASHBOARD_MODES[currentUserMode].route;
  }

  if (!isLoggedIn) {
    return LOGIN_K12;
  }

  return '/';
};

export const CONTEXT_MODE_ELEMENTARY = 'elementary';
export const CONTEXT_MODE_SECONDARY = 'secondary_and_alumni';
export const CONTEXT_MODE_ELEMENTARY_AND_SECONDARY = 'elementary_and_secondary';

export const getCurrentUserMode = (userModes = []) => {
  let currentUserMode;
  if (isEmpty(userModes)) {
    currentUserMode = null;
    return currentUserMode;
  }
  currentUserMode = userModes.find(mode => mode?.isCurrent);
  if (!currentUserMode) {
    currentUserMode = userModes.find(mode => mode?.hasPriority);
  }
  if (!currentUserMode) {
    currentUserMode = MIDDLE_HIGH_SCHOOL_MODE_KEY;
  }

  return currentUserMode;
};

export const checkUserTypeMatchesUserMode = ({
  userType,
  currentUserMode,
  isElementaryRoute,
}) => {
  if (currentUserMode === ELEMENTARY_MODE_KEY) {
    return userType === USER_TYPES.K12_ADMIN && isElementaryRoute;
  }
  if (currentUserMode === GUARDIAN_MODE_KEY) {
    return [USER_TYPES.MEMBER, USER_TYPES.GUARDIAN].includes(userType);
  }
  if (currentUserMode === MIDDLE_HIGH_SCHOOL_MODE_KEY) {
    return !isElementaryRoute && userType === USER_TYPES.K12_ADMIN;
  }

  return true;
};
